import { decryptAES, truncateString } from '@/utils/utils';
import { Tag } from 'antd';
import React from 'react';

const AccountName = ({ size = 'medium', accountData, showTag = true }) => {
  const { provider, accName, userkeys, isActive } = accountData;
  const headingSize = size === 'medium' ? 14 : size === 'small' ? 12 : 24;
  const logoSize = size === 'medium' ? 30 : size === 'small' ? 20 : 40;

  let accId = '';
  let accLogo = `/icons/${provider.toLowerCase()}_sm_icon.svg`;

  if (provider.toLowerCase() === 'aws') {
    accId = accountData.awsAccountId;
  } else if (userkeys && provider.toLowerCase() === 'azure') {
    const userData = JSON.parse(decryptAES(userkeys));
    accId = userData.subscriptionId;
  } else if (userkeys && provider.toLowerCase() === 'gcp') {
    const userData = JSON.parse(decryptAES(userkeys));
    accId = userData.projectId;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <img alt="accName" style={{ width: logoSize }} src={accLogo} />
      <div
        style={{
          marginLeft: 16,
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: headingSize,
            fontWeight: 500,
          }}
        >
          {accName}{' '}
          {showTag && (
            <Tag
              style={{
                borderRadius: 8,
                fontSize: 10,
                marginLeft: 6,
                marginBottom: 2,
              }}
              color={isActive ? 'blue' : 'warning'}
              bordered={false}
            >
              {isActive ? 'Active' : 'Inactive'}
            </Tag>
          )}
        </p>
        <p
          style={{
            margin: 0,
            fontSize: 12,
            opacity: 0.45,
            color: 'rgba(0, 0, 0, 0.85)',
          }}
        >
          {size === 'large' ? accId : truncateString(accId, 48)}
        </p>
      </div>
    </div>
  );
};

export default AccountName;
